import { ProductsService } from './../../../../services/products.service';
import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Question, UserAnswer } from 'src/app/models/products/transactions';
import { TransactionsService } from 'src/app/services/transactions.service';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements  OnChanges {
  @Input() questions: Array<Question>;
  userAnswers: Array<UserAnswer> = [];
  questionOptions = [];

  @Output() userAnswerChange: EventEmitter<Array<UserAnswer>> = new EventEmitter<Array<UserAnswer>>();
  constructor(private route: ActivatedRoute,
    private _transactionsService: TransactionsService) {

  }

  ngOnChanges(): void {
    const trnsIndex = this.route.snapshot.params.i;
    if (trnsIndex) {
      this.userAnswers = this._transactionsService.clientTransactionsView$.getValue()[trnsIndex].UserAnswers;
      this.questions.forEach((question) => {
        this.questionOptions.push(JSON.parse(question.OptionsStr));
      });
      this.userAnswerChange.emit(this.userAnswers);
    } else if (this.questions) {
      this.questions.forEach((question) => {
        const userAnswer = new UserAnswer();
        userAnswer.UserAnswerStr = '';
        userAnswer.QuestionId = question.Id;
        userAnswer.QuestionStr = question.QuestionStr;
        if (question.Type === 5) {
          userAnswer.UserAnswerStr = JSON.parse(question.OptionsStr)[0];
        }
        this.userAnswers.push(userAnswer);
        this.questionOptions.push(JSON.parse(question.OptionsStr));
      });
      this.userAnswerChange.emit(this.userAnswers);
    }

  }
  changeAnswer(questionIndex, event): void {
    if (event.target.type === 'checkbox' && this.userAnswers[questionIndex].UserAnswerStr.indexOf(event.target.value) > -1) {

      let res = this.userAnswers[questionIndex].UserAnswerStr.replace(event.target.value + ',', '');
      res = res;
      this.userAnswers[questionIndex].UserAnswerStr = res;
    } else if (event.target.type === 'checkbox') {
      this.userAnswers[questionIndex].UserAnswerStr += event.target.value + ',';
    } else {
      this.userAnswers[questionIndex].UserAnswerStr = event.target.value;
    }
    this.userAnswerChange.emit(this.userAnswers);
  }
}
